export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'https://staging.api.ecollect.sidcoop.org',
  reportApiUrl: 'https://staging.api.reports.sidcoop.org',
  apiVersion: '1'
};